<template>
  <a
    v-if="isPinned"
    href="#"
    class="btn mb-4 w-full"
    @click.prevent="unpin(post)"
  >
    Unpin this resource <i
      class="icon-sm icon-reg icon-collapse"
      aria-hidden="true"
    />
  </a>
  <a
    v-else
    href="#"
    class="btn btn-outlined mb-4 w-full"
    @click.prevent="pin(post)"
  >
    Pin this resource <i
      class="icon-sm icon-reg icon-expand"
      aria-hidden="true"
    />
  </a>
</template>

<script>
export default {

  props: {
    post: {
      type: Number,
      required: true,
    },
    propPin: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isPinned: false,
    };
  },
  computed: {
    computedPin() {
      return this.propPin;
    },
  },

  mounted() {
    this.isPinned = this.computedPin;
  },

  methods: {
    pin(post) {
      window.axios.post('/pin/' + post)
        .then(() => this.isPinned = true)
        .catch(response => console.log(response.data));
    },

    unpin(post) {
      window.axios.post('/unpin/' + post)
        .then(() => this.isPinned = false)
        .catch(response => console.log(response.data));
    }
  },
};
</script>
